import React, { Component } from 'react'
import './styles.css'

class AlertTemplate extends Component {
  componentDidMount () {
    // Fails in safari, needs permissions from user to play audio
    // this.refs['audio'].play()
    navigator.vendor !== 'Apple Computer, Inc.' && this.refs['audio'].play()
  }

  render () {
    const { message, close } = this.props

    return (
      <div className='alert-template'>
        {/* {options.type === 'info' && '!'}
        {options.type === 'success' && ':)'}
        {options.type === 'error' && ':('} */}
        {message}
        <button className='alert-bttn' onClick={close}>X</button>
        <audio ref='audio'>
          <source src='/sounds/intuition.mp3' />
        </audio>
      </div>
    )
  }
}

export default AlertTemplate



// WEBPACK FOOTER //
// ./src/components/common/popups/AlertTemplate.js